import request from '../utils/request'; 
const querystring = require('querystring')


//登录
export const login = query => {  
    var list = request({
        url: 'common/login.do',
        header:{"token":localStorage.getItem(window.location.hostname+'_token')},
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};
export const getFidByPhone = query => {
    var list = request({
        url: 'haoka/hkMember/getFidByPhone.do',
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};



export const rePass = query => {
    var list = request({
        url: 'haoka/hkUser/restPass.do',
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};
export const rePhone = query => {
    var list = request({
        url: 'haoka/hkUser/resetPhone.do',
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};
export const resetInfo = query => {
    var list = request({
        url: 'haoka/hkUser/resetInfo.do',
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};




